import { type FC } from 'react'

import {
  type UserOrderResponseV2,
  type UserOrderResponseWithFlags,
} from '@redteclab/api/clients/bully'
import { IconCaretRight } from '@redteclab/icons'

import {
  OrderImageItem,
  userSubOrderAccessorGetMultipleProductThumbnailAndName,
  userSubOrderAccessorIsProductErx,
} from '../../../../order'

const MAX_ITEMS = 3
const MAX_IMAGE_THUMBNAILS = 2

export const DirectContactFormOrderSelectionCardImageThumbnail: FC<{
  order: UserOrderResponseWithFlags | UserOrderResponseV2
}> = ({ order }) => {
  const productInfo =
    userSubOrderAccessorGetMultipleProductThumbnailAndName(order)

  return (
    <div className="mt-2 flex w-full flex-row justify-between">
      <ul className="flex gap-2">
        {productInfo.map((item, index) => {
          if (!item.itemName) {
            return null
          }

          const isERx = userSubOrderAccessorIsProductErx(item)

          return (
            index < MAX_ITEMS && (
              <OrderImageItem
                alt={item.itemName}
                data-qa-id={`direct-contact-form-${item.pzn}`}
                isERx={isERx}
                key={isERx ? item.hashedToken : item.offerId}
                src={item.thumbnailURL}
              />
            )
          )
        })}
        {productInfo.length > MAX_IMAGE_THUMBNAILS &&
        productInfo.length - MAX_ITEMS > 0 ? (
          <li className="flex size-16 items-center justify-center text-m">
            {`+${productInfo.length - MAX_ITEMS}`}
          </li>
        ) : null}
      </ul>
      <span className="flex items-center">
        <IconCaretRight className="size-8 fill-dark-brand" />
      </span>
    </div>
  )
}
